import { CHANGE_ENDPOINT } from "../actions/networkAction";
import { TEST_NET } from "../utils/WalletUtils";
const defaultState = {
  endpoint: TEST_NET,
};

const NetworkReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "CHANGE_ENDPOINT":
      return { ...state, endpoint: action.endpoint };
    default:
    // do nothing
  }
  return state;
};
export default NetworkReducer;
